export enum UserSubRoleEnum {
  FOOTBALL_REFEREE = "FOOTBALL_REFEREE",
  FOOTBALL_FAN = "FOOTBALL_FAN",
  SPORTS_COMMENTATOR = "SPORTS_COMMENTATOR",
  SPORTS_BROADCASTER = "SPORTS_BROADCASTER",
  SPORTS_JOURNALIST = "SPORTS_JOURNALIST",
  FOOTBALL_PERFORMANCE_ANALYST = "FOOTBALL_PERFORMANCE_ANALYST",
  FOOTBALL_ANALYST = "FOOTBALL_ANALYST",
  TEAM_PHYSICIAN = "TEAM_PHYSICIAN",
  FITNESS_COACH = "FITNESS_COACH",
  PHYSIOTHERAPIST = "PHYSIOTHERAPIST",
  NUTRITIONIST = "NUTRITIONIST",
  FOOTBALL_CLUB_GENERAL_MANAGER = "FOOTBALL_CLUB_GENERAL_MANAGER",
  FOOTBALL_CLUB_DIRECTOR = "FOOTBALL_CLUB_DIRECTOR",
  FOOTBALL_CLUB_OWNER = "FOOTBALL_CLUB_OWNER",
  FOOTBALL_MANAGER = "FOOTBALL_MANAGER",
  SPORTS_WRITER = "SPORTS_WRITER",
  SPORTS_EVENT_COORDINATOR = "SPORTS_EVENT_COORDINATOR",
  OTHER = "OTHER",
  ENTITY_ADMIN = "ENTITY_ADMIN",
}

export enum UserRoleEnum {
  PLAYER = "PLAYER",
  AGENT = "AGENT",
  COACH = "COACH",
  SCOUT = "SCOUT",
  OTHER = "OTHER",
}
export const userRoleList = Object.values(UserRoleEnum);
